import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { displaceDateRange } from '@/utils/url';
import { calculateVariation } from '@/utils/math';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class CallExportsService extends Service {
  constructor(gateway) {
    const api = createApi('/productivity', gateway, {
      authNotFound: () => true,
    });

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  getOverallProductivity(params) {
    return this.find({
      ...params,
      url: '/overall',
    });
  }

  getDailyProductivity(params) {
    return this.find({
      ...params,
      url: '/daily',
    });
  }

  async getOverallProductivityWithVariation({ params = {}, ...options }) {
    const { originalParams, displacedParams } = displaceDateRange(params);
    const [data, displacedData] = await Promise.all([
      this.getOverallProductivity({ params: originalParams, ...options }),
      this.getOverallProductivity({ params: displacedParams, ...options }),
    ]);

    return {
      currentValue: data.overallProductivity,
      previousValue: displacedData.overallProductivity,
      productivityVariation: calculateVariation(displacedData.overallProductivity, data.overallProductivity),
    };
  }
}

export default new CallExportsService(gateway);
